import { parseAsArrayOf, parseAsJson, parseAsString, parseAsStringEnum } from 'nuqs';

import { dayjs } from '@/utilities';

// Search text (string)
export const searchQuery = parseAsString.withDefault('');

export const searchMatchModes = ['partial', 'exact'] as const;
export type SearchMatchMode = (typeof searchMatchModes)[number];
export const searchMatchModeQuery = parseAsStringEnum<SearchMatchMode>([...searchMatchModes]).withDefault('partial');

export const searchModes = ['automatic', 'keyword', 'semantic'] as const;
export type SearchMode = (typeof searchModes)[number];
export const searchModeQuery = parseAsStringEnum<SearchMode>([...searchModes]);
export const resolveSearchMode = (
    requestedMode: SearchMode | null | undefined,
    canUseAdvancedSearch: boolean,
): SearchMode => (canUseAdvancedSearch ? (requestedMode ?? 'automatic') : 'keyword');

// Recent searchs text (string)
export const recentSearchesQuery = parseAsString.withDefault('');

// General JSON query state. Search routes use the compact `searchFiltersQuery`
// codec so internal filter-envelope metadata never leaks into user-facing URLs.
export const filtersQuery = parseAsJson<any>((value) => value).withDefault({});

export { listSortQuery } from './listSort';
export type { ListSortDirection, ListSortQueryValue } from './listSort';

// Redirect path (string)
export const redirectQuery = parseAsString.withDefault('');

// Auth token (string)
export const tokenQuery = parseAsString.withDefault('');

// Referral program invite code / provider click id (strings)
export const referralQuery = parseAsString.withDefault('');
export const dubClickIdQuery = parseAsString.withDefault('');

// Homepage Dashboard Id (String)
export const dashboardQuery = parseAsString;

// Report ID (string)
export const reportQuery = parseAsString;

// List View ID (string)
export const viewQuery = parseAsString;

// Task detail drawer ID (string)
export const taskQuery = parseAsString.withOptions({ history: 'push', shallow: true });

// OAuth Application Consent ID (string)
export const consentQuery = parseAsString;

// Sensitive, single-purpose capability consumed by the public unsubscribe route.
export const unsubscribeTokenQuery = parseAsString.withOptions({ history: 'replace', shallow: true });

// Metric Line Items

export const tagsQuery = parseAsArrayOf(parseAsString).withDefault([]).withOptions({ history: 'replace' });

export const tagsStartDateQuery = parseAsString.withDefault(dayjs().subtract(15, 'year').format('YYYY-MM-DD'));
export const tagsEndDateQuery = parseAsString.withDefault(dayjs().format('YYYY-MM-DD'));

export const tagsSegmentedValueQuery = parseAsStringEnum(['annual', 'quarter']).withDefault('annual');
